import { getActiveDowntimes } from "./downtimes";
import { Fragment } from "react/jsx-runtime";
import { CalDataLine, CalJob, CalProject } from "./InnerCalendar";
import {
  CalendarContext,
  CalendarElementsProps,
} from "@/components/shared/VerticalCalendar";
import { useContext } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { Edit, Search } from "@mui/icons-material";

export default function InnerCalendar({
  offset,
  data,
  readOnly,
  setJobInfoId
}: {
  offset: number;
  readOnly: boolean;
  setJobInfoId: (id: number | null) => void;
  data: CalDataLine<CalProject, CalJob>;
}) {
  const navigate = useNavigate();
  const view = useContext(CalendarContext);
  const days = [];
  const ostart = dayjs(data.plannedStart);
  const oend = dayjs(data.plannedEnd);
  const xstart = ostart < view.calStart ? view?.calStart : ostart;
  const xend = oend > view.calEnd ? view?.calEnd : oend;

  

  for (let date in data.elements) {
    const dd = dayjs(date, "YYYY-MM-DD");

    if (dd < view?.calStart || dd > view?.calEnd) continue;

    for (let i = 0; i < data.elements[date].length; i++) {
      const element = data.elements[date][i];
      const downtimes = getActiveDowntimes(element.phase?.downtimes, date);
      const downtime = downtimes.length > 0;
      const downtimeComment = downtimes.map((item) => item.comment).join("; ");

      days.push(
        <div
          className={"vc-date color "+(downtime ? "orange" : !!element.orderSentAt ? "darkgreen" : element.status === "PLANNING"
            ? "blue"
            : element.status === "RAW"
            ? "yellow"
            :element.status === "READY"
            ? "orange"
            : "green")}
          data-date={date}
          key={"phase" + date + i}
          style={{
            display: "flex",
            justifyContent: "space-between",
            gridRow: offset,
            gridColumn: dd.diff(view.calStart, "days") + 2,
          }}
          title={downtime ? `Stillstand: ${downtimeComment}` : undefined}
        >{downtime ? <div style={{ color: "white", fontSize: 10, overflow: "hidden" }}>Stillstand: {downtimeComment}</div> : null}<div className="resOrderEdit">
        
        <div
                            className="resOrderButton"
                            onClick={() => setJobInfoId(element.id)}
                          >
                            <Search fontSize="inherit" />
                          </div>
      </div></div>
      );
    }
  }

  return (
    <Fragment>
      <div
        key={"sidebar" + offset}
        className={"vc-sidebar project"}
        style={{
          gridRow: offset,
        }}
      >
        {!!data?.number ? data?.number + ": " : ""}
        {data.name}
      </div>

      {days}
      <div
        className="vc-hl"
        key={"hl" + offset}
        style={{
          gridRow: offset,
          gridColumn: 2 + " / " + (view.calEnd.diff(view.calStart, "days") + 2),
        }}
      ></div>
    </Fragment>
  );
}
